import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

const Contact = () => {
        const [formData, setFormData] = useState({
            name: '',
            email: '',
            phone: '',
            message: ''
        });

        const [errors, setErrors] = useState({
            email: '',
            phone: ''
        });

        const [status, setStatus] = useState({
            submitting: false,
            submitted: false,
            error: false,
            message: ''
        });

        const isValidEmail = (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        };

        const isValidPhone = (phone) => {
            const phoneRegex = /^(\+91[\-\s]?)?[6-9]\d{9}$/;
            return phoneRegex.test(phone);
        };

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({...formData, [name]: value });

            if (name === 'email') setErrors({...errors, email: '' });
            if (name === 'phone') setErrors({...errors, phone: '' });
        };

        const validateForm = () => {
            let valid = true;
            const newErrors = { email: '', phone: '' };

            if (!formData.email) {
                newErrors.email = 'Email is required';
                valid = false;
            } else if (!isValidEmail(formData.email)) {
                newErrors.email = 'Please enter a valid email address';
                valid = false;
            }

            if (!formData.phone) {
                newErrors.phone = 'Phone number is required';
                valid = false;
            } else if (!isValidPhone(formData.phone)) {
                newErrors.phone = 'Please enter a valid Indian mobile number';
                valid = false;
            }

            setErrors(newErrors);
            return valid;
        };

        const handleSubmit = async(e) => {
            e.preventDefault();

            if (!validateForm()) return;

            setStatus({ submitting: true, submitted: false, error: false, message: '' });

            try {
                const response = await axios.post('http://localhost:5000/api/contact', formData);

                if (response.data.success) {
                    setStatus({
                        submitting: false,
                        submitted: true,
                        error: false,
                        message: response.data.message
                    });
                    setFormData({ name: '', email: '', phone: '', message: '' });
                }
            } catch (error) {
                console.error('Error:', error);
                setStatus({
                    submitting: false,
                    submitted: false,
                    error: true,
                    message: 'Failed to send message. Please try again later.'
                });
            }
        };

        return ( <
                div className = "contact" > { /* Hero Section */ } <
                div className = "contact-hero" >
                <
                div className = "hero-pattern" > < /div> <
                div className = "container" >
                <
                div className = "hero-logo-wrapper" >
                <
                span className = "hero-logo-main" > VICHITRRARANYA < /span> <
                span className = "hero-logo-sub" > Foundation < /span> <
                /div> <
                h1 > Contact Us < /h1> <
                p > Have questions or want to get involved ? We 'd love to hear from you.</p> <
                /div> <
                div className = "hero-wave" >
                <
                svg viewBox = "0 0 1440 180"
                fill = "none"
                xmlns = "http://www.w3.org/2000/svg" >
                <
                path d = "M0 180L60 157.5C120 135 240 90 360 67.5C480 45 600 45 720 56.25C840 67.5 960 90 1080 101.25C1200 112.5 1320 112.5 1380 112.5L1440 112.5V180H1380C1320 180 1200 180 1080 180C960 180 840 180 720 180C600 180 480 180 360 180C240 180 120 180 60 180H0Z"
                fill = "white" / >
                <
                /svg> <
                /div> <
                /div>

                { /* Contact Content */ } <
                div className = "contact-content-section" >
                <
                div className = "container" >
                <
                div className = "contact-grid" > { /* Contact Info Cards */ } <
                div className = "contact-info-side" >
                <
                h3 className = "info-heading" > Contact Information < /h3> <
                div className = "info-cards" >
                <
                div className = "info-card"
                style = {
                    { borderTop: '4px solid #2e7d32' } } >
                <
                div className = "info-icon-wrapper"
                style = {
                    { backgroundColor: '#e8f5e9' } } >
                <
                span className = "info-icon" > 📧 < /span> <
                /div> <
                div className = "info-details" >
                <
                h4 style = {
                    { color: '#2e7d32' } } > Email < /h4> <
                a href = "mailto:parikshitkarale00@gmail.com"
                className = "info-link" > parikshitkarale00 @gmail.com < /a> <
                /div> <
                /div> <
                div className = "info-card"
                style = {
                    { borderTop: '4px solid #1976d2' } } >
                <
                div className = "info-icon-wrapper"
                style = {
                    { backgroundColor: '#e3f2fd' } } >
                <
                span className = "info-icon" > 📞 < /span> <
                /div> <
                div className = "info-details" >
                <
                h4 style = {
                    { color: '#1976d2' } } > Phone < /h4> <
                a href = "tel:+919876543210"
                className = "info-link" > +91 9876543210 < /a> <
                /div> <
                /div> <
                div className = "info-card"
                style = {
                    { borderTop: '4px solid #c2185b' } } >
                <
                div className = "info-icon-wrapper"
                style = {
                    { backgroundColor: '#fce4ec' } } >
                <
                span className = "info-icon" > 📍 < /span> <
                /div> <
                div className = "info-details" >
                <
                h4 style = {
                    { color: '#c2185b' } } > Address < /h4> <
                p className = "info-text" > India < /p> <
                /div> <
                /div> <
                /div> <
                /div>

                { /* Contact Form */ } <
                div className = "contact-form-side" >
                <
                div className = "form-container" >
                <
                h3 className = "form-heading" > Send us a Message < /h3>

                {
                    status.submitted && ( <
                        div className = "alert success" >
                        <
                        span className = "alert-icon" > ✓ < /span> {status.message} <
                        /div>
                    )
                } {
                    status.error && ( <
                        div className = "alert error" >
                        <
                        span className = "alert-icon" > ✗ < /span> {status.message} <
                        /div>
                    )
                }

                <
                form onSubmit = { handleSubmit }
                className = "contact-form" >
                <
                div className = "form-group" >
                <
                label > Your Name < /label> <
                input type = "text"
                name = "name"
                placeholder = "Enter your name"
                value = { formData.name }
                onChange = { handleChange }
                required /
                >
                <
                /div>

                <
                div className = "form-row" >
                <
                div className = "form-group half" >
                <
                label > Email Address < /label> <
                input type = "email"
                name = "email"
                placeholder = "Enter your email"
                value = { formData.email }
                onChange = { handleChange }
                required className = { errors.email ? 'error-input' : '' }
                /> {
                    errors.email && < span className = "error-message" > { errors.email } < /span>} <
                        /div>

                    <
                    div className = "form-group half" >
                        <
                        label > Phone Number < /label> <
                        input
                    type = "tel"
                    name = "phone"
                    placeholder = "Enter your phone number"
                    value = { formData.phone }
                    onChange = { handleChange }
                    required
                    className = { errors.phone ? 'error-input' : '' }
                    /> {
                        errors.phone && < span className = "error-message" > { errors.phone } < /span>} <
                            /div> <
                            /div>

                        <
                        div className = "form-group" >
                            <
                            label > Your Message < /label> <
                            textarea
                        name = "message"
                        placeholder = "How can we help you?"
                        rows = "5"
                        value = { formData.message }
                        onChange = { handleChange }
                        required
                            >
                            < /textarea> <
                            /div>

                        <
                        button type = "submit"
                        className = "submit-btn"
                        disabled = { status.submitting } > { status.submitting ? < span > Sending... < /span> : <span>Send Message ✈️</span > } <
                            /button> <
                            /form> <
                            /div> <
                            /div> <
                            /div> <
                            /div> <
                            /div> <
                            /div>
                    );
                };

                export default Contact;